export default __webpack_public_path__ + "d923cfbc7564e8f40833a369ec6a645d.woff";